import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      mirrors: {
        mirrors_list_js: {
          add_tracking: {
            save: 'JS_SAVE_BTN',
            back: 'JS_BACK_BTN',
            tabs: {
              from_file: {
                header: 'JS_FROM_FILE_HEADER',
                description: 'JS_FROM_FILE_DESCRIPTION',
                errors_in_file: 'JS_FROM_FILE_ERROR',
              },
            },
          },
        },
        mirrors_list_no_js: {
          add_tracking: {
            save: 'NO_JS_SAVE_BTN',
            back: 'NO_JS_BACK_BTN',
            tabs: {
              from_file: {
                header: 'NO_JS_FROM_FILE_HEADER',
                description: 'NO_JS_FROM_FILE_DESCRIPTION',
                errors_in_file: 'NO_JS_FROM_FILE_ERROR',
              },
            },
          },
        },
      },
    },
  }));
}
